import {useMutation} from "react-query";
import {CreateResidentDto} from "../types";
import {ResidentService} from "../../../services/ResidentServices";
import Alert from "react-s-alert";
import {useHistory} from "react-router";

export const useCreateResident = () => {
  const history = useHistory();

  return useMutation(
    async (body: CreateResidentDto) => {
      const response = await ResidentService.createResident(body);
      return response;
    },
    {
      onSuccess: response => {
        Alert.success("Resident successfully created!");
        const residentId = response.data?.id;
        history.push(
          residentId ? `/admin/residents/${residentId}` : "/admin/residents",
        );
      },
      onError: (err: any) => {
        Alert.error(
          err?.data?.detail ? err?.data?.detail : "Something went wrong",
        );
      },
    },
  );
};
